import React from 'react'
const mobbanner = "https://winpeforum.com/assets/elements/probanner-mob.jpg"
import img2 from '../../images/probanner-mob.jpg'
import './herosection.css'
import MediaQuery from "react-responsive"
import Link from "gatsby-link";
export class herosection extends React.Component{
constructor(args){
    super(args);
    this.state;
}

render(){
    return(
        <div className="hero-section-wrapper">
        	<MediaQuery query="(min-width: 767px)">
            <Link to="/cohortII/" className="">
                        <img
                          src="https://www.winpeforum.com/assets/elements/pro-banner-new2.png"
                          alt="winpe proclub"
                        />
                      </Link>
	           
		    </MediaQuery>
		    <MediaQuery query="(max-width: 767px)">
            <Link to="/cohortII/" className="">
                        <img
                          src="https://winpeforum.com/assets/elements/probanner-mob2.jpg"
                          alt="winpe proclub"
                        />
                      </Link>   
            
		    </MediaQuery>
        </div>
    )
}

}

export default herosection


// WEBPACK FOOTER //
// ./src/components/heroSection/index.jsx